import {Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef} from "@angular/core";
import {Subscription} from "rxjs";
import {ActivatedRoute} from "@angular/router";
import {AccessControlService} from "../services/access-control.service";
import {AppEventBus} from "../event-buses/app.event-bus";
import {AppEventName} from "../event-buses/AppEventName";

@Directive({
  selector: '[linkAccessControl]'
})
export class AccessControlDirective implements OnInit, OnDestroy {

  private viewCreated = false;

  private hasAccess = true;
  private accessName: string|null = null;
  private additionalCondition = true;
  private additionalConditionType: string|null = null;

  private subscription: Subscription|null = null;

  constructor(private template: TemplateRef<any>,
              private container: ViewContainerRef,
              private route: ActivatedRoute,
              private accessControlService: AccessControlService,
              private appEventBus: AppEventBus) {

  }

  @Input('linkAccessControl') set setAccessName(accessName: string) {
    this.accessName = accessName;
    this.checkAccess();
  }

  @Input('linkAccessControlAndIf') set andIf(result: boolean) {
    this.additionalCondition = result;
    this.additionalConditionType = 'and';
    this.checkAccess();
  }

  @Input('linkAccessControlOrIf') set orIf(result: boolean) {
    this.additionalCondition = result;
    this.additionalConditionType = 'or';
    this.checkAccess();
  }

  ngOnInit() {
    this.subscription = this.appEventBus.subscribe(AppEventName.NewUserSession, (data) => {
      console.log(`Rechecking access after user session update`);
      this.checkAccess();
    });
  }

  ngOnDestroy() {
    if(this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }

  private checkAccess() {
    const parentAccessName = this.accessControlService.getAccessNameFromRoute(this.route);
    this.hasAccess = this.accessControlService.checkUserAccess(this.accessName!, parentAccessName);

    let shouldCreateView = this.hasAccess;

    if(this.additionalConditionType === 'and') {
      shouldCreateView = this.hasAccess && this.additionalCondition;
    }
    else if(this.additionalConditionType === 'or') {
      shouldCreateView = this.hasAccess || this.additionalCondition;
    }

    if(shouldCreateView && !this.viewCreated) {
      this.container.createEmbeddedView(this.template);
      this.viewCreated = true;
    }
    else if(!shouldCreateView) {
      this.container.clear();
      this.viewCreated = false;
    }
  }
}
